import { createContext, useContext } from 'react';

export interface SortableContextValue<T = Record<string, unknown>> {
  displayByValueLookup: Record<string, React.ReactNode>;
  dataByValueLookup: Record<string, T>;
  shouldHighlight?: (data: T) => boolean;
  onItemClicked?: (data: T) => void;
}

export const SortableContext = createContext<SortableContextValue | null>(null);

export const useSortableContext = () => {
  const context = useContext(SortableContext);
  if (context === null) {
    throw new Error('useSortableContext must be used within Sortable');
  }
  return context;
};
